import { jsx as _jsx } from "react/jsx-runtime";
import { InsiderHighlightedBenefitBanner } from "@faire/retailer-visitor-shared/views/user/InsiderMarketing/components/InsiderHighlightedBenefitBanner";
import { optimizeImageUrlFillRectangle } from "@faire/web--source/common/images/optimizeImages";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { useResponsiveValue } from "@faire/web--source/ui/hooks/useResponsiveValue";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import * as React from "react";
// TODO(Kim): Make this banner BE driven - return view focused proto for the InsiderHighlightedBenefitBanner
export var InsiderEarlyAccessBanner = function() {
    var isSSR = useIsSSR();
    var _useResponsiveValue;
    var imgSrc = (_useResponsiveValue = useResponsiveValue({
        mobileAndAbove: optimizeImageUrlFillRectangle({
            url: "https://cdn.faire.com/fastly/0e440e81ee72a3e7dc1358989ee9fa10274ae925c61164772b4067991b4ea82c.jpeg"
        }, isSSR, 375, 314),
        tabletAndAbove: optimizeImageUrlFillRectangle({
            url: "https://cdn.faire.com/fastly/6b6e83411398f0af61493a3400024d9c83c0bb78b0898efbc26619a4d2fc82df.jpeg"
        }, isSSR, 440, 500)
    })) !== null && _useResponsiveValue !== void 0 ? _useResponsiveValue : "";
    return /*#__PURE__*/ _jsx(InsiderHighlightedBenefitBanner, {
        imgSrc: imgSrc,
        title: /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "88bT5R",
            defaultMessage: [
                {
                    type: 0,
                    value: "Get the best deals, first"
                }
            ]
        }),
        description: /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "60uRDz",
            defaultMessage: [
                {
                    type: 0,
                    value: "Insider members get exclusive, 24-hour early access to Faire\u2019s virtual trade shows\u2014helping you find the best deals of the season, first."
                }
            ]
        })
    });
};
